import { attributes, AttributesMixin, define, Model, type } from "@type-r/models";
import { isEmpty } from "lodash";
import { poll } from "../shared";
import { AssetTypeItem } from "./assetTypes";
import { getAuthorizationBearer, getPlatformCode, restfulIO } from "./endpoint";

export interface PlatformProduct extends AttributesMixin<typeof PlatformProduct> { }
@define
export class PlatformProduct extends Model {

    static idAttribute = "uid";

    static attributes = {
        code: String,
        name: String,
        sendToProductEnabled: Boolean
    }

}

export interface PlatformProducts extends AttributesMixin<typeof PlatformProducts> { }
@define
export class PlatformProducts extends Model {
    static endpoint = restfulIO('/api/v1/lookups/{platformCode}/products');

    static attributes = {
        items: [PlatformProduct],
        count: Number
    }

    async getPlatformProducts(platformCode): Promise<PlatformProducts> {
        const url = `api/v1/lookups/${platformCode}/products`;

        const response = await fetch(url, {
            method: 'GET',
            headers: new Headers({
                "Authorization": getAuthorizationBearer(),
                'X-Platform-Code': getPlatformCode()
            }),
        });

        if (response.status < 200 || response.status >= 300) {
            let error = response.statusText || `HTTP Error ${response.status}`;
            await response.json()
                .then(e => error = e.error)
                .catch(e => console.error('Cannot parse response data'));
            throw new Error(error);
        }

        const json = await response.json();

        this.set(json);
        return this;
    }
}
